import { render, staticRenderFns } from "./integral-collect.vue?vue&type=template&id=35450f41&scoped=true"
import script from "./integral-collect.vue?vue&type=script&lang=js"
export * from "./integral-collect.vue?vue&type=script&lang=js"
import style0 from "./integral-collect.vue?vue&type=style&index=0&id=35450f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35450f41",
  null
  
)

export default component.exports